import { TInitialData } from 'types/Navigation/RootNavigation';

export const getInitialUserData: TInitialData = (infoUserDispatch, role) => {
  infoUserDispatch({
    type: 'INFO_SUCCESS',
    role,
  });
};
